import { render, staticRenderFns } from "./ServiceFilter.vue?vue&type=template&id=5c867a65&"
import script from "./ServiceFilter.vue?vue&type=script&lang=js&"
export * from "./ServiceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports